import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users.component';
import { UserIndexComponent } from './user-index/user-index.component';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserFormComponent } from './user-form/user-form.component';
import {CardModule} from '../../resources/components/card/card.module';
import {UsersRoutesModule} from './users-routes/users-routes.module';
import {FormGroupContextModule} from '../../resources/modules/form-group-context/form-group-context.module';
import {FormGroupSimpleModule} from '../../resources/modules/form-group-context/form-group-simple/form-group-simple.module';
import {ValidateModule} from '../../resources/modules/validate/validate.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TableUserModule} from '../../resources/tables/table-user/table-user.module';
import { UserViewComponent } from './user-view/user-view.component';
import {TableDeviceModule} from '../../resources/tables/table-device/table-device.module';
import {TablePurchaseModule} from '../../resources/tables/table-purchase/table-purchase.module';
import {TableProjectModule} from '../../resources/tables/table-project/table-project.module';
import { UserViewPurchasesComponent } from './user-view/user-view-purchases/user-view-purchases.component';
import { UserViewProjectsComponent } from './user-view/user-view-projects/user-view-projects.component';
import { UserViewStoreComponent } from './user-view/user-view-store/user-view-store.component';
import { UserViewInfoComponent } from './user-view/user-view-info/user-view-info.component';
import { UserViewStoreCollectionsComponent } from './user-view/user-view-store-collections/user-view-store-collections.component';
import {TableStoreCollectionModule} from '../../resources/tables/table-store-collection/table-store-collection.module';
import { UserViewActionStatesComponent } from './user-view/user-view-action-states/user-view-action-states.component';
import {TableActionStateModule} from '../../resources/tables/table-action-state/table-action-state.module';
import {ModalBonusModule} from '../../resources/components/modals/modal-bonus/modal-bonus.module';
import { UserViewCoinFlowComponent } from './user-view/user-view-coin-flow/user-view-coin-flow.component';
import {TableCoinFlowModule} from '../../resources/tables/table-coin-flow/table-coin-flow.module';
import {EntityLinkModule} from "../../resources/components/entity-link/entity-link.module";
import {RouterOuterDirectiveModule} from "../../resources/directives/router-outer-directive/router-outer-directive.module";
import {SharedModule} from "../../modules/shared.module";
import {IconsModule} from '../../resources/components/icons/icons.module';
import {BtnDeleteModule} from '../../resources/components/btn-delete/btn-delete.module';
import {TabsRouteModule} from "../../resources/components/tabs-route/tabs-route.module";



@NgModule({
  declarations: [
    UsersComponent,
    UserIndexComponent,
    UserEditComponent,
    UserFormComponent,
    UserViewComponent,
    UserViewPurchasesComponent,
    UserViewProjectsComponent,
    UserViewStoreComponent,
    UserViewInfoComponent,
    UserViewStoreCollectionsComponent,
    UserViewActionStatesComponent,
    UserViewCoinFlowComponent
  ],
  imports: [
    CommonModule,
    CardModule,
    UsersRoutesModule,
    FormGroupContextModule,
    FormGroupSimpleModule,
    ValidateModule,
    FormsModule,
    ReactiveFormsModule,
    TableUserModule,
    TableDeviceModule,
    TablePurchaseModule,
    TableProjectModule,
    TableStoreCollectionModule,
    TableActionStateModule,
    ModalBonusModule,
    TableCoinFlowModule,
    EntityLinkModule,
    RouterOuterDirectiveModule,
    SharedModule,
    IconsModule,
    BtnDeleteModule,
    TabsRouteModule
  ]
})
export class UsersModule { }
